export default __webpack_public_path__ + "static/media/74t.43aad630.jpg";